import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  level0ThumbPng,
  level1ThumbPng,
  level2ThumbPng,
  level3ThumbPng,
  level4ThumbPng,
  level5ThumbPng,
  level6ThumbPng,
  level7ThumbPng,
  level8ThumbPng,
} from '../../assets/images';
import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import { SITE_LINKS } from '../../constants';
import { useGetLevels } from '../../hooks/use-get-levels';
import { getLevelCardButtonText, getLevelCardStatus } from '../../models/LevelsPageLevel';
import { Background } from '../../stories/Background';
import { LevelCarousel } from '../../stories/LevelCarousel';

const levelCarouselImages = [
  level0ThumbPng,
  level1ThumbPng,
  level2ThumbPng,
  level3ThumbPng,
  level4ThumbPng,
  level5ThumbPng,
  level6ThumbPng,
  level7ThumbPng,
  level8ThumbPng,
];

export const LevelsPage = () => {
  const { levels, isFetching, isError } = useGetLevels();
  const __ = useTranslation().t;
  const currentLevel = levels.find((level) => level.current);
  const currentLevelIndex = (currentLevel?.position || 1) - 1;
  const defaultImgSrc = levelCarouselImages[0];
  const levelsData = levels.map((level) => {
    const cardStatus = getLevelCardStatus(level, currentLevel?.position || 1);
    const cardButtonText = getLevelCardButtonText(level, cardStatus, __);
    return {
      ...level,
      title: __('levelNumber', { 1: level.position }),
      imgSrc: levelCarouselImages[level.position] || defaultImgSrc,
      status: cardStatus,
      buttonText: cardButtonText,
      buttonHref: SITE_LINKS.LevelDetailsPage(level.position),
    };
  });

  if (isError) {
    window.location.href = SITE_LINKS.HomePage;
    return null;
  }

  return (
    <>
      <DefaultHeader activeItem={__('course')} />
      <Background>
        {isFetching ? (
          <LoadingContainer />
        ) : (
          <div className="oejr-page-levels">
            <LevelCarousel levels={levelsData || []} currentLevelIndex={currentLevelIndex} />
          </div>
        )}
      </Background>
    </>
  );
};
